import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Form, FormGroup, Input } from 'reactstrap';
import style from './SearchForm.module.css';




function isInViewPort(ref) {
    const [isIntersecting, setIntersecting] = useState(false)

    const observer = useMemo(() => new IntersectionObserver(
        ([entry]) => setIntersecting(entry.isIntersecting)
    ), [ref])


    useEffect(() => {
        observer.observe(ref.current)
        return () => observer.disconnect()
    }, [])

    return isIntersecting
}

const SearchForm = (state) => {
    const getValueById = (id) => document.getElementById(id).value;
    const getByName = (id) => document.getElementsByName(id);
    const handleChange = v => { state.changeDocumentType(v); }

    const searchButtonRef = useRef(null)
    const isSearchButtonVisible = isInViewPort(searchButtonRef)

    const onFormSubmit = (e) => {
        e.preventDefault();
        if (!state || !state.fields) {
            console.log("The are no form fields. Cannot perform search");
            return;
        }
        const docType = state.selected;
        const attributes = {};
        for (var i = 0; i < state.fields.length; i++) {
            const key = state.fields[i]['name'];
            const elem = getByName(key);
            if (state.fields[i].type == "date" && elem.length > 1) {
                const from = elem[0].id == "from" ? elem[0].value : elem[1].value;
                const to = elem[0].id == "to" ? elem[0].value : elem[1].value;
                if (from && to) attributes[key] = "/btw/" + from + "," + to
                else if (from) attributes[key] = "/gte/" + from;
                else if (to) attributes[key] = "/lte/" + to;
            }
            else {
                const value = getValueById(key);
                if (value !== "") {
                    attributes[key] = value;
                }
            }
        }
        state.setSearchCriteria({ docType, attributes });
        state.searchDocuments(docType, attributes);
    }

    return (
        <div className={style.searchForm}>
            <Form>
                <FormGroup className={style.formGroup}>
                    <h4 className={style.title}>{state.strings['Documenttypes']}</h4>
                    <Input type="select" className={style.select} name="select" id="documentTypes" value={state.selected} onChange={(e) => { handleChange(e.target.value); }}>
                        {state.types}
                    </Input>
                </FormGroup>

                <hr className={style.divider} />
                <h4 className={style.title}>Metadata</h4>
                {state.form}
                <hr className={style.divider} />
                <button className={style.searchButton} ref={searchButtonRef} onClick={onFormSubmit}>{state.strings['Search']}</button>
                {!isSearchButtonVisible && <button id="stickyButton" className={style.stickyButton} onClick={onFormSubmit}>{state.strings['Search']}</button>}

            </Form >
        </div >
    )
}
export default SearchForm;